

function init() {
    // First check if alert bar exists
    const alertBar = document.getElementById('sbkAlertBar');
    if (!alertBar) return;

    const alertId = alertBar.dataset.alertId;
    const startTime = alertBar.dataset.start;
    const endTime = alertBar.dataset.end;

    // Function to check if a cookie exists
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    // Function to set a cookie
    function setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    }

    // Function to check if current time is within range (NY timezone)
    function isTimeInRange() {
        // Create a formatter that will give us NY time
        const nyFormatter = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });

        const now = new Date();
        const nyTimeStr = nyFormatter.format(now)
            .replace(/(\d+)\/(\d+)\/(\d+),\s+(\d+):(\d+):(\d+)/, '$3-$1-$2 $4:$5:$6');
        const nyTime = new Date(nyTimeStr);

        // Check start time if it exists
        if (startTime) {
            const start = new Date(startTime);
            if (nyTime < start) return false;
        }

        // Check end time if it exists
        if (endTime) {
            const end = new Date(endTime);
            if (nyTime > end) return false;
        }

        return true;
    }

    // Check if we should show the alert
    if (!getCookie(`alert_dismissed_${alertId}`) && isTimeInRange()) {
        alertBar.style.display = 'block'; // or remove a hidden class
    }

    // Handle close button click
    const closeButton = document.getElementById('closeAlertBar');
    if (closeButton) {
        closeButton.addEventListener('click', function() {
            alertBar.style.display = 'none';
            setCookie(`alert_dismissed_${alertId}`, 'true', 365); // Cookie lasts 1 year
        });
    }
};

export {init as default}